import { useEffect } from 'react';
import { notification } from '@zen-common/components-base';
import { RedeemStore } from '../../stores/FixedPayoutStore';

export default function RedeemErrors() {
  const {
    state: { fetchPhase },
  } = RedeemStore.useStore();

  useEffect(() => {
    switch (fetchPhase) {
      case 'node-fetch':
        notification('Fetching mint data from node...', { type: notification.TYPE.INFO });
        break;
      case 'oracle-fetch':
        notification('Querying the oracle service...', { type: notification.TYPE.INFO });
        break;
      default:
        break;
    }
  }, [fetchPhase]);

  return null;
}
